import axios from 'axios'
import { baseApiUrl } from '../config/config'
import { throwError } from '../utils/error'

export const postFeedback = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/feedback/set`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throwError(err)
    // return null
  }
}

export const getFeedbackTypes = async (params) => {
  // console.log(params)
  try {
    const res = await axios.get(`${baseApiUrl}/feedback-types`)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err)
    // return null
  }
}
